module.exports = __webpack_public_path__ + "img/razorPay.d7114420.png";